import {api} from '../../../system/api';

export default {
    editShippingUser: (data) => api.put(`shipping-users/${data.id}`, data)
};
